module.exports = __webpack_public_path__ + "static/img/p_19.531fe33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_19.jpg
// module id = m/BD
// module chunks = 9